import React, {
    useContext
} from 'react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from 'shared/components/ui/dropdown-menu';
import {
    Check, ChevronDown, Info
} from 'lucide-react';
import {
    Tooltip,
    TooltipProvider,
    TooltipTrigger,
} from 'shared/components/ui/tooltip';
import {
    KBContext
} from 'builders/builderKnowledge/knowledgeBuilderContext/KBGlobalContext';
import {
    cn
} from 'shared/lib/utils';
import KBTooltipContent from './KBTooltipContent';

const LabelWithTooltip = ({
    label, tooltipText
}) => (
    <div className="flex items-center gap-2 mb-1">
        <span className="text-sm font-medium">{label}</span>
        {tooltipText && (
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger>
                        <Info className="w-3 h-3 text-muted-foreground" />
                    </TooltipTrigger>
                    <KBTooltipContent tooltipText={tooltipText} />
                </Tooltip>
            </TooltipProvider>
        )}
    </div>
);

const KBDropdownItem = ({
    children, onSelect, checked, disabled
}) => (
    <DropdownMenuItem
        onSelect={() => {
            onSelect();
        }}
        disabled={disabled}
        className="flex items-center justify-between cursor-pointer"
    >
        {children}
        {checked && <Check className="w-4 h-4 ml-2" />}
    </DropdownMenuItem>
);

export default function KBDropdown({
    title,
    selectedValue,
    setter,
    options,
    required,
    tooltipText,
    handleDisplaySelectedOption = () => null,
    className,
    triggerClassName
}) {
    return (
        <div className={cn(className)}>
            <div className="flex items-center gap-1 relative mb-1">
                <LabelWithTooltip label={title} tooltipText={tooltipText} />
                {required && <span className="text-[red] mb-1">*</span>}
            </div>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button className={`rounded-md shadow-sm border-input text-foreground p-1 px-3 text-sm text-left flex items-center justify-between border font-normal w-full ${triggerClassName || ''}`}>
                        <p className="truncate">{selectedValue ? selectedValue.label : `Select ${title}`}</p>
                        <ChevronDown size={15} />
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-[--radix-dropdown-menu-trigger-width]">
                    {options().map((option, index) => (
                        <KBDropdownItem
                            key={index}
                            checked={selectedValue?.value === option.value}
                            onSelect={() => {
                                if (selectedValue?.value !== option.value) setter(option);
                                else setter(null);
                            }}
                        >
                            {option.label}
                        </KBDropdownItem>
                    ))}
                    {handleDisplaySelectedOption()}
                    {options().length < 1 && <div className="text-xs select-none text-foreground p-2">No items.</div>}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}

export const KBL1FilterDropdown = (props) => {
    const {
        tableHandler
    } = useContext(KBContext);

    const handleDisplaySelectedOption = () => (
        <KBDropdownItem disabled={tableHandler.selectedDocs.size < 1} onSelect={() => {
            if (props.selectedValue?.value !== 'selected') props.setter({
                value: 'selected',
                label: `${tableHandler.selectedDocs.size} Selected`
            });
            else props.setter(null);
        }} checked={props.selectedValue?.value === 'selected'}>
            ({tableHandler.selectedDocs.size}) Selected
        </KBDropdownItem>
    );

    return <KBDropdown {...props} handleDisplaySelectedOption={handleDisplaySelectedOption} />;
};

export const KBL2FilterDropdown = (props) => <KBDropdown {...props} />;